import { render, staticRenderFns } from "./TopPick.vue?vue&type=template&id=4e4da0b6&scoped=true&"
import script from "./TopPick.vue?vue&type=script&lang=js&"
export * from "./TopPick.vue?vue&type=script&lang=js&"
import style0 from "./TopPick.vue?vue&type=style&index=0&id=4e4da0b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4da0b6",
  null
  
)

export default component.exports